import { RadioProps } from 'semantic-ui-react';

export const generateRadioButtonOptions = (
    labels: Array<string>,
    groupName: string,
    getMessage: Function,
    messageKey: string = groupName,
    values?: Array<string | number>): Array<RadioProps> => {

  return labels.map((label, index) => ({
        id: label,
        label: getMessage(`${messageKey}.${label}`),
        name: groupName,
        value: values ? values[index] : index
      }
  ));
};

export const generateRadioButtonOptionsFromEnum = (
    labels: Array<string>,
    groupName: string,
    getMessage: Function): Array<RadioProps> => {

  return labels.map(label => ({
        id: label,
        label: getMessage(`${groupName}.${label}`),
        name: groupName,
        value: label
      }
  ));
};

export const generateRadioButtonOptionsFromEnumAndPrefix = (
    labels: Array<string>,
    groupName: string,
    labelPrefix: string,
    getMessage: Function): Array<RadioProps> => {

  return labels.map(label => ({
        id: `${groupName}.${label}`,
        label: getMessage(`${labelPrefix}.${label}`),
        name: groupName,
        value: label
      }
  ));
};
